<template>
  <el-radio-group v-bind="$attrs" v-on="$listeners">
    <template v-if="showType == 'radio'">
      <el-radio v-for="item in items" v-bind:key="item.codeValue" :label="item.codeValue">
        {{item.codeText}}
      </el-radio>
    </template>
    <template v-else>
      <el-radio-button v-for="item in items" v-bind:key="item.codeValue" :label="item.codeValue">
        {{item.codeText}}
      </el-radio-button>
    </template>
  </el-radio-group>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  extends: BaseVue,
  props: {
    codeType: {
      default: ''
    },
    parentCode: {
      require: false,
      default: null
    },
    showType: {
      type: 'radio' | 'radio-button',
      default: 'radio'
    }
  },
  data() {
    return {
      items: []
    }
  },
  created() {
    this.getCodes(this.codeType, this.parentCode).then((dr) => {
      this.items = dr.rows || []
    });
  }
}
</script>
